import { render, staticRenderFns } from "./RegistrationPaymentForm.vue?vue&type=template&id=186d8978&scoped=true"
import script from "./RegistrationPaymentForm.vue?vue&type=script&lang=js"
export * from "./RegistrationPaymentForm.vue?vue&type=script&lang=js"
import style0 from "./RegistrationPaymentForm.vue?vue&type=style&index=0&id=186d8978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186d8978",
  null
  
)

export default component.exports